import React, { Component } from 'react';
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import UpdateModal from './UpdateModal.js';
import ImportFromPassword from './ImportFromPassword';
import CreatorDashboardSidebar from './CreatorDashboardSidebar';
import CreatorDashboardProfile from './CreatorDashboardProfile';
import CreatorDashboardReactions from './CreatorDashboardReactions';
import Subscribers from "./Subscribers";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class CreatorDashboard extends Component {
  constructor(props) {
    super(props);
    this.addOrReplaceEmote = this.addOrReplaceEmote.bind(this);
    this.removeEmote = this.removeEmote.bind(this);
    this.selectModal = this.selectModal.bind(this);
    this.selectTab = this.selectTab.bind(this);
    this.setCreatorBackgroundBlurredImage = this.setCreatorBackgroundBlurredImage.bind(this);
    this.setCreatorImage = this.setCreatorImage.bind(this);
    this.setDiscord = this.setDiscord.bind(this);
    this.setInstagram = this.setInstagram.bind(this);
    this.setSpotify = this.setSpotify.bind(this);
    this.setTwitter = this.setTwitter.bind(this);
    this.setRoute = this.setRoute.bind(this);
    this.setUsername = this.setUsername.bind(this);
    this.submitProfileInfo = this.submitProfileInfo.bind(this);

    this.state = {
      emotes: [],
      modalShown: '',
      creatorBackgroundBlurredImage: '',
      creatorImage: '',
      discord: '',
      instagram: '',
      spotify: '',
      twitter: '',
      username: '',
      route: '',
      streamerProfileInfo: null,
      selectedTab: "profile",
    }
  }

  selectTab(selectedTab) {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_dashboard",
      "creator_dashboard_switch_tab",
      "info",
      "https://the402.xyz",
      {
        selectedTab
      }
    );
    this.setState({
      selectedTab,
    });
  }

  async submitProfileInfo() {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_dashboard",
      "creator_dashboard_submit_profile_info",
      "info",
      "https://the402.xyz",
      {}
    );
    let existingProfile = await encryptUtils.getStreamerProfileInfo(this.state.route);
    if(existingProfile.creatorAddress.toLowerCase() !== this.props.account.address.toLowerCase()) {
      let streamerProfileInfo = await encryptUtils.getStreamerProfileInfo(this.props.account.address);
      let username = streamerProfileInfo.creatorName;
      let route = streamerProfileInfo.name;
      let emotes = streamerProfileInfo.emotes;
      emotes = emotes.filter(emoteInfo => emoteInfo.length === 1);
      let filteredStreamerProfileInfo = {
        "authUUIDCrossmintClientMapping": streamerProfileInfo.authUUIDCrossmintClientMapping,
        "creatorAddress": streamerProfileInfo.creatorAddress,
        "creatorBackgroundBlurredImage": streamerProfileInfo.creatorBackgroundBlurredImage,
        "creatorImage": streamerProfileInfo.creatorImage,
        "creatorName": streamerProfileInfo.creatorName,
        "emotes": streamerProfileInfo.emotes,
        "liveNFTAuthUUID": streamerProfileInfo.liveNFTAuthUUID,
        "liveNFTProtocol": streamerProfileInfo.liveNFTProtocol,
        "livestreamGatingLogicMetadata": streamerProfileInfo.livestreamGatingLogicMetadata,
        "livestreamURLPreviews": streamerProfileInfo.livestreamURLPreviews,
        "livestreamURLs": streamerProfileInfo.livestreamURLs,
        "livestreamURLsByAuthUUID": streamerProfileInfo.livestreamURLsByAuthUUID,
        "liveTimesByAuthUUID": streamerProfileInfo.liveTimesByAuthUUID,
        "nftSalesLivestream": streamerProfileInfo.nftSalesLivestream,
        "shouldStreamInTestMode": streamerProfileInfo.shouldStreamInTestMode,
        "socials": streamerProfileInfo.socials,
      }
      this.setState({
        creatorAddress: this.props.account.address.toLowerCase(),
        creatorBackgroundBlurredImage: streamerProfileInfo.creatorBackgroundBlurredImage,
        creatorImage: streamerProfileInfo.creatorImage,
        discord: streamerProfileInfo.socials.discord != null ? streamerProfileInfo.socials.discord : '',
        emotes,
        instagram: streamerProfileInfo.socials.instagram != null ? streamerProfileInfo.socials.instagram : '',
        spotify: streamerProfileInfo.socials.spotify != null ? streamerProfileInfo.socials.spotify : '',
        twitter: streamerProfileInfo.socials.twitter != null ? streamerProfileInfo.socials.twitter : '',
        route,
        username,
        streamerProfileInfo: filteredStreamerProfileInfo,
        modalShown: "failureUpdate"
      });
    } else {
      let streamerProfileInfo = this.state.streamerProfileInfo;
      streamerProfileInfo["creatorBackgroundBlurredImage"] = this.state.creatorBackgroundBlurredImage;
      streamerProfileInfo["creatorImage"] = this.state.creatorImage;
      if(this.state.discord !== null) {
        streamerProfileInfo["socials"]["discord"] = this.state.discord !== '' ? this.state.discord : null;
      }
      if(this.state.instagram !== null) {
        streamerProfileInfo["socials"]["instagram"] = this.state.instagram !== '' ? this.state.instagram : null;
      }
      if(this.state.spotify !== null) {
        streamerProfileInfo["socials"]["spotify"] = this.state.spotify !== '' ? this.state.spotify : null;
      }
      if(this.state.twitter !== null) {
        streamerProfileInfo["socials"]["twitter"] = this.state.twitter !== '' ? this.state.twitter : null;
      }
      streamerProfileInfo["name"] = this.state.route;
      streamerProfileInfo["creatorName"] = this.state.username;
      if(this.state.emotes.length > 0) {
        streamerProfileInfo["emotes"] = this.state.emotes;
      }
      await encryptUtils.updateStreamerProfileInfo(this.state.route, this.props.account.address.toLowerCase(), streamerProfileInfo);
      this.setState({
        modalShown: "successUpdate",
      });
    }
  }

  async setCreatorBackgroundBlurredImage(file) {
    let creatorId = this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId();
    let creatorBackgroundBlurredImage = await encryptUtils.writeSingleFilePinata(
      creatorId + "_creator_bg",
      file
    );
    this.setState({
      creatorBackgroundBlurredImage,
    });
  }

  async setCreatorImage(file) {
    let creatorId = this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId();
    let creatorImage = await encryptUtils.writeSingleFilePinata(
      creatorId + "_creator_pfp",
      file
    );
    this.setState({
      creatorImage,
    });
  }

  setDiscord(event) {
    this.setState({
      discord: event.target.value,
    });
  }

  async addOrReplaceEmote(emoteFile, i) {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_dashboard",
      "creator_dashboard_add_or_replace_emote",
      "info",
      "https://the402.xyz",
      {}
    );
    let emotes = this.state.emotes;
    let emoteCount = emotes.length;
    let creatorId = this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId();
    let emoteURL = await encryptUtils.writeSingleFilePinata(
      creatorId + "_emote_" + emoteCount.toString(),
      emoteFile
    );
    if(emoteCount <= i) {
      emotes.push([emoteURL]);
    } else {
      emotes[i] = [emoteURL];
    }
    this.setState({
      emotes,
    });
  }

  removeEmote(i) {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "creator_dashboard",
      "creator_dashboard_remove_emote",
      "info",
      "https://the402.xyz",
      {}
    );
    let emotes = this.state.emotes;
    emotes.splice(i, 1);
    this.setState({
      emotes,
    });
  }

  setInstagram(event) {
    this.setState({
      instagram: event.target.value,
    });
  }

  setSpotify(event) {
    this.setState({
      spotify: event.target.value,
    });
  }

  setTwitter(event) {
    this.setState({
      twitter: event.target.value,
    });
  }

  setRoute(event) {
    this.setState({
      route: event.target.value,
    });
  }

  setUsername(event) {
    this.setState({
      username: event.target.value,
    });
  }

  async componentDidMount() {
    if(this.props.account !=  null) {
      let streamerProfileInfo = await encryptUtils.getStreamerProfileInfo(this.props.account.address);
      if(streamerProfileInfo != null && Object.keys(streamerProfileInfo).length > 0) {
        let username = streamerProfileInfo.creatorName;
        let route = streamerProfileInfo.name;
        let emotes = streamerProfileInfo.emotes;
        emotes = emotes.filter(emoteInfo => emoteInfo.length === 1);
        let filteredStreamerProfileInfo = {
          "authUUIDCrossmintClientMapping": streamerProfileInfo.authUUIDCrossmintClientMapping,
          "creatorAddress": streamerProfileInfo.creatorAddress,
          "creatorBackgroundBlurredImage": streamerProfileInfo.creatorBackgroundBlurredImage,
          "creatorImage": streamerProfileInfo.creatorImage,
          "creatorName": streamerProfileInfo.creatorName,
          "emotes": streamerProfileInfo.emotes,
          "liveNFTAuthUUID": streamerProfileInfo.liveNFTAuthUUID,
          "liveNFTProtocol": streamerProfileInfo.liveNFTProtocol,
          "livestreamGatingLogicMetadata": streamerProfileInfo.livestreamGatingLogicMetadata,
          "livestreamURLPreviews": streamerProfileInfo.livestreamURLPreviews,
          "livestreamURLs": streamerProfileInfo.livestreamURLs,
          "livestreamURLsByAuthUUID": streamerProfileInfo.livestreamURLsByAuthUUID,
          "liveTimesByAuthUUID": streamerProfileInfo.liveTimesByAuthUUID,
          "nftSalesLivestream": streamerProfileInfo.nftSalesLivestream,
          "shouldStreamInTestMode": streamerProfileInfo.shouldStreamInTestMode,
          "socials": streamerProfileInfo.socials,
        }
        this.setState({
          creatorAddress: this.props.account.address.toLowerCase(),
          creatorBackgroundBlurredImage: streamerProfileInfo.creatorBackgroundBlurredImage,
          creatorImage: streamerProfileInfo.creatorImage,
          discord: streamerProfileInfo.socials.discord != null ? streamerProfileInfo.socials.discord : '',
          emotes,
          instagram: streamerProfileInfo.socials.instagram != null ? streamerProfileInfo.socials.instagram : '',
          spotify: streamerProfileInfo.socials.spotify != null ? streamerProfileInfo.socials.spotify : '',
          twitter: streamerProfileInfo.socials.twitter != null ? streamerProfileInfo.socials.twitter : '',
          route,
          username,
          streamerProfileInfo: filteredStreamerProfileInfo,
        });
      }
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "creator_dashboard",
        "creator_dashboard_page_load",
        "info",
        "https://the402.xyz",
        {}
      );
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    return (
      <div>
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
          {
            this.state.modalShown === 'createAccount'
              ?
            <Onboarding selectModal={this.selectModal} />
              :
            this.state.modalShown === 'addFunds'
              ?
            <AddFunds selectModal={this.selectModal} />
              :
            this.state.modalShown === 'importFromPassword'
              ?
            <ImportFromPassword selectModal={this.selectModal} />
              :
            (this.state.modalShown === "successUpdate" || this.state.modalShown === "failureUpdate")
              ?
            <UpdateModal
              selectModal={this.selectModal}
              status={this.state.modalShown}
              url={window.location.origin + "/profile/" + this.state.route}
            />
              :
            null
          }
        </div>
        <div className="w-screen min-h-screen flex">
          <CreatorDashboardSidebar
            selectTab={this.selectTab}
            selectedTab={this.state.selectedTab}
          />
          {
            this.state.selectedTab === "profile"
              ?
            <CreatorDashboardProfile
              creatorAddress={this.state.creatorAddress}
              creatorBackgroundBlurredImage={this.state.creatorBackgroundBlurredImage}
              creatorImage={this.state.creatorImage}
              discord={this.state.discord}
              instagram={this.state.instagram}
              spotify={this.state.spotify}
              twitter={this.state.twitter}
              route={this.state.route}
              username={this.state.username}
              setCreatorBackgroundBlurredImage={this.setCreatorBackgroundBlurredImage}
              setCreatorImage={this.setCreatorImage}
              setDiscord={this.setDiscord}
              setTwitter={this.setTwitter}
              setSpotify={this.setSpotify}
              setInstagram={this.setInstagram}
              setRoute={this.setRoute}
              setUsername={this.setUsername}
              submitProfileInfo={this.submitProfileInfo}
            />
              :
            null
          }
          {
            this.state.selectedTab === "reactions"
              ?
            <CreatorDashboardReactions
              emotes={this.state.emotes}
              addOrReplaceEmote={this.addOrReplaceEmote}
              removeEmote={this.removeEmote}
              submitProfileInfo={this.submitProfileInfo}
            />
              :
            null
          }
          {
            this.state.selectedTab === "subscribers"
              ?
            <Subscribers
              account={this.props.account}
            />
              :
            null
          }
        </div>
      </div>
    );
  }
}

export default CreatorDashboard;
